import { required, confirmed, min, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: "กรุณากรอกข้อมูล"
});

extend("email", {
  ...email,
  message: "กรุณากรอกอีเมลให้ถูกต้อง"
});

extend("confirmed", {
  ...confirmed,
  message: "กรุณากรอกรหัสผ่านให้ตรงกัน"
});

extend("min",(value, args) => {
  if(value.length >= Number(args[0])) {
    return true
  }
  return `รหัสผ่านต้องมีอย่างน้อย ${args[0]} ตัวอักษร`
});
